import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-iframe-page',
  templateUrl: './iframe-page.component.html',
  styleUrls: ['./iframe-page.component.scss']
})
export class IframePageComponent implements OnInit {

  constructor(public sanitizer: DomSanitizer,
    private dialog: MatDialog) { }

  ngOnInit() {
  }

  close(){
    this.dialog.closeAll();
  }
 

}
